module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8640/img/design-manager.svg"